module.exports = __webpack_public_path__ + "img/632f1eba4a0d2fb0c7685838_3.da78b119.png";